import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

// Mirrors a server boundary rather than creating one: Hasura denies debug_data on org_audit_logs to
// roles without this permission, so a query that selects or filters on it is rejected. The client
// must know before it asks — to pick the debugData-free page document, to skip the predecessor
// query, and to withhold the record-scoped affordance, whose WHERE clause filters on the column.
export default function isAllowedToReadAuditLogDebugData() {
  return isAllowed(permissions.readAuditLogDebugData);
}
